import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Button,
  Badge,
} from 'reactstrap';

import {
  Field,
} from 'redux-form';

import TextBox from '../../../../shared/components/form/TextBox';

const ObjetivosMateriaTable = ({
  materiaPeriodo,
  fields = {},
  meta: { error, submitFailed },
  onDeleteItemArray,
  onChangeText,
  items,
}) => {
  const isNew = items.some(o => !o.deleted && o.id === 0);
  return (
    <div className="form__form-group-field" style={{ flexDirection: 'column' }}>
      <div>
        <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
          {fields.map((objetivo, index) => {
            if (!items[index]) {
              return null;
            }
            return (
              <div
                key={`${objetivo}`}
                id={`${objetivo}`}
                style={{ borderRadius: '10px', padding: '0' }}
                className={(items[index].deleted || (items[index].id > 0 && isNew)) ? 'hidden' : ''}
              >
                <div style={{ borderTop: '0' }}>
                  <Row
                    className="wizard__subform"
                    style={{
                      borderRadius: '10px', borderTop: '0', marginRight: '0', marginLeft: '0',
                    }}
                  >
                    <Col md={12}>
                      <div style={{
                        display: 'flex',
                        gap: '1rem',
                        justifyItems: 'center',
                        justifyContent: 'flex-start',
                        alignItems: 'baseline',
                        padding: '0.4rem',
                      }}
                      >
                        <h3><Badge color="primary">#{index + 1}</Badge></h3>
                        {
                          materiaPeriodo.canEditarPlaneamiento ? (
                            <th className="col col-1">
                              <Button
                                onClick={() => onDeleteItemArray({ name: fields.name, index })}
                                size="sm"
                                outline
                                color="danger"
                                style={{ marginBottom: '0px' }}
                                className="font-weight-bold"
                              >
                                <i className="fa fa-trash" aria-hidden="true" />
                              </Button>
                            </th>
                          ) : null
                        }
                      </div>
                    </Col>

                    <div className="col-md-12 col-sm-12">
                      <div style={{ marginBottom: '1rem' }}>
                        <span className="form__form-group-label required">Objectivo:</span>
                        <div className="form" style={{ display: 'flex' }}>
                          <div
                            className="form__form-group-input-wrap form__form-group-input-wrap--error "
                            style={{ display: 'flex' }}
                          >
                            <Field
                              name={`${objetivo}.objetivo`}
                              placeholder="Objetivo"
                              type="textarea"
                              style={{ minHeight: '13rem' }}
                              maxLength="1024"
                              autofocus={items[index].id === 0}
                              disabled={!materiaPeriodo.canEditarPlaneamiento}
                              readOnly={!materiaPeriodo.canEditarPlaneamiento}
                              component={TextBox}
                              autoComplete="false"
                              onChange={({ target }) => onChangeText({ target, name: fields.name, index })}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
              </div>
            );
          })}
        </div>
        {
          submitFailed && error && (
            <span className="form__form-group-error" style={{ marginBottom: '0.5rem' }}>
              {error}
            </span>
          )
        }
      </div>
    </div>
  );
};

ObjetivosMateriaTable.propTypes = {
  onDeleteItemArray: PropTypes.func.isRequired,
  onChangeText: PropTypes.func.isRequired,
  fields: PropTypes.shape({}).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  materiaPeriodo: PropTypes.shape({}).isRequired,
};

ObjetivosMateriaTable.defaultProps = {
  meta: {},
};

export default ObjetivosMateriaTable;
